import { render, staticRenderFns } from "./pais-form.vue?vue&type=template&id=479072a6&scoped=true"
import script from "./pais-form.vue?vue&type=script&lang=js"
export * from "./pais-form.vue?vue&type=script&lang=js"
import style0 from "./pais-form.vue?vue&type=style&index=0&id=479072a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479072a6",
  null
  
)

export default component.exports